fx.ns("desktop.frame", class Main extends shared.BaseMain {

	constructor() 
	{
		super(new repositories.FrameRepository());

        fx.set("app", "frame"); 
	}

    init()
	{
		this.views = [  "desktop.common.screens.Splash",
						"desktop.common.screens.Saving",
						"desktop.common.photoimport.UploadProgress",
						"desktop.frame.FrameEditor",
						"desktop.frame.PhotoChoices",
                        "desktop.frame.FrameChoice",
					 ];
		this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);
	}


    onDataEvent(e)
	{
		super.onDataEvent(e);
		
		switch(e.type)
		{
			case "start":
				if (this.model.creationid)
				{
					this.steps("Splash", "FrameEditor");
				}
				else
				{
                    fx.set("mode", "creating");
                    
					this.steps({view : "Splash", skipPrevious : true}, "FrameChoice", "PhotoChoices", "FrameEditor"); // ajouter editeur
				}
            break;

            /*case "edit-photo" :
				this.switchTo("EditPhoto", {photo : e.data, model : this.model});
				break;*/

            /*case "edit-text" :
				this.switchTo("EditText", {text : e.data, model : this.model});
				break;*/

            case "upload-progress":
				this.popup(new desktop.common.photoimport.UploadProgress(this.model));
				break;

            case "frame-choice" : 
                this.switchTo("FrameChoice");
            break;

            case "order" :
				if (this.readyLeaving(e.type))
					this.model.event("navigate-order", null, 500);
			break;

			case "import-mobile":
				this.popup(new shared.popups.EnterPhoneNumber(this.model));
			break;

			case "mobile-upload-started":
				this.popup(null);
				this.switchTo("FrameEditor");	
			break;

            case "exit-editor" :
				if (this.readyLeaving(e.type))
					this.model.event("navigate-exit", null, 500);
				break;

			case "selectphotos" :
				this.switchTo("PhotoChoices", e.detail);
				break;

			case "show-editor":
				this.actionRequested = ""
				this.switchTo("FrameEditor");
				break;

			
        }
    }

	_toggleGridMode(e)
	{
		fx.get("settings").toggleGridMode();
		
        e.stopPropagation();
		e.preventDefault();
	}
	
});